type CreateKeyProps = {
  brandName: string
  number: string
}

export function createKey({ brandName, number }: CreateKeyProps) {
  return JSON.stringify([brandName.toLowerCase(), number.toLowerCase()])
}
